export default __webpack_public_path__ + "static/media/filling_2.a30906f7.jpg";